<template>
  <div class="bank-codes-page">
    <h1>Bank Codes</h1>
    <div v-show="load">
      <white-loader />
    </div>
    <table>
      <thead>
        <tr>
          <th>Bank Name</th>
          <th>Bank Code</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(bank, index) in banks" :key="index">
          <td>{{ bank.bank }}</td>
          <td>{{ bank.code }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
  
  <script>
import * as types from "../../../store/constant";
import whiteLoader from "../../partials/white-loader.vue";

export default {
  components: { whiteLoader },
  data() {
    return {
      load: false,
      banks: [],
    };
  },
  mounted() {
    this.fetchBankCodes();
  },
  methods: {
    fetchBankCodes() {
      this.load = true;
      this.$http
        .get(`${types.GET_BANK_CODES}`)
        .then((response) => {
            
          if (response.data.status && response.data.data) {
            this.banks = response.data.data;
            this.load = false;
          } else {
            console.error("Invalid response format");
          }
        })
        .catch((error) => {
          console.error("Error fetching bank codes:", error);
        });
    },
  },
};
</script>
  
<style>
.bank-codes-page {
  max-width: 800px;
  margin: 0 auto;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

th,
td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

th {
  background-color: #f2f2f2;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

tr:hover {
  background-color: #ddd;
}
</style>